import { apiClient } from "@/api/api-client";
import ReactECharts from "echarts-for-react";
import { useEffect, useState } from "react";

const colors = {
	pending: "#f87171",
	withDecision: "#eab308",
	withAppeal: "#3b82f6",
	caseClosed: "#82ca9d",
};

const CourtsChart = () => {
	const defaultOptions = {
		legend: {},
		tooltip: {
			trigger: "axis",
			axisPointer: {
				type: "shadow",
			},
		},
		yAxis: {
			splitNumber: 10,
			minInterval: 1,
		},
		xAxis: {
			type: "category",
			nameTextStyle: {
				fontWeight: "bold",
			},
		},
		series: [
			{ type: "bar", color: colors.pending },
			{ type: "bar", color: colors.withDecision },
			{ type: "bar", color: colors.withAppeal },
			{ type: "bar", color: colors.caseClosed },
		],
		dataset: {},
	};

	const [statistics, setStatistics] = useState([]);

	const fetchData = async () => {
		const response = await apiClient.get("/backoffice/court-statistics");
		if (response && response.data) {
			const temp: any = [];

			response.data.forEach((item: { title: any; data: any }) => {
				temp.push({
					...defaultOptions,
					extras: {
						title: item.title,
					},
					dataset: {
						source: [["status", "Pending w/o Decision", "Pending w/ Decision", "With Appeal", "Case Closed"], ...item.data],
					},
				});
			});

			setStatistics(temp);
		}
	};

	useEffect(() => {
		fetchData();
	}, []);

	return (
		<div className="grid grid-cols-12 w-full gap-4">
			{statistics &&
				statistics.map((item: any, index: number) => (
					<div className="col-span-12" key={index}>
						<div className="flex flex-col w-full gap-4">
							<div className="flex flex-col w-full h-auto rounded-md border border-border/50 overflow-hidden">
								<div className="flex flex-row w-full p-3 border-b border-border/50 items-center">
									<div className="flex flex-col w-6/12 text-base font-semibold text-foreground-dark">{item.extras.title}</div>
								</div>
								<div
									style={{
										width: "100%",
										height: 400,
									}}
								>
									<ReactECharts option={item} style={{ height: "100%", width: "100%" }} />
								</div>
							</div>
						</div>
					</div>
				))}
		</div>
	);
};

export default CourtsChart;
